var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer-container"},[_vm._v(" 广东微牛电子商务有限公司版权所有 ")])}
var staticRenderFns = []

export { render, staticRenderFns }